import { combineReducers } from '@reduxjs/toolkit'
import { UserReducer } from '~/Store/User'
import { WaitOverlayReducer } from '~/Store/Overlays'
import { LayoutReducer } from '~/Store/Layout'
import { OrganizationReducer } from './Organization'
import { GlobalReducer } from './Global'
import { DevicesReducer } from './Devices'
import { LicenseMgmtReducer } from './License'
import { ClaimReducer } from './Claims'
import { RolesReducer } from './Role'
import { UsersReducer } from './AdminUser'
import { OpenIddictApplicationReducer } from './OpenIddictApplications'
import { LoginBrandingReducer } from './LoginBranding'
import { BootstrapReducer } from './Bootstrap'
import { StaffReducer } from './Staff'
import { GroupReducer } from './Groups'
import { OrganizationRoleReducer } from './OrganizationRoles'
import { ClientReducer } from './Client'
import { ServicePrincipalReducer } from './ServicePrincipal'
import { ApiKeyReducer } from './ApiKey'
import { ProductReducer } from './Products'

const rootReducer = combineReducers({
  bootstrap: BootstrapReducer,
  users: UsersReducer,
  roles: RolesReducer,
  global: GlobalReducer,
  user: UserReducer,
  waitOverlays: WaitOverlayReducer,
  layout: LayoutReducer,
  organization: OrganizationReducer,
  devices: DevicesReducer,
  license: LicenseMgmtReducer,
  claim: ClaimReducer,
  staff: StaffReducer,
  groups: GroupReducer,
  organizationRoles: OrganizationRoleReducer,
  client: ClientReducer,
  openIddictApplication: OpenIddictApplicationReducer,
  loginBranding: LoginBrandingReducer,
  servicePrincipal: ServicePrincipalReducer,
  apiKey: ApiKeyReducer,
  product: ProductReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
